/**
 * Copyright © 2018 Emu Analytics
 */

import { Client } from './client';
import { IStyle } from './api-interfaces';
import { BaseEndpoints } from './base.endpoints';

export class StyleEndpoints extends BaseEndpoints<IStyle> {
  constructor(client: Client) {
    super(client, 'styles');
  }
}
